'use client';

import { forwardRef } from 'react';
import { Input as RizzuiInput, type InputProps as RizzuiInputProps } from 'rizzui';

export type InputProps = Omit<RizzuiInputProps, 'type'> & {
  type?: RizzuiInputProps['type'] | 'file';
};

export const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  return <RizzuiInput ref={ref} {...(props as RizzuiInputProps)} />;
});

Input.displayName = 'Input';
